<template>
  <div class="container-fluid">
    <page-header
      :page="page"
      :actions="headerActionConfig"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    />

    <search-filter ref="filter" @close-callout="closeResultsCallout" />

    <SearchResult
      ref="results"
      @status-has-changed="filterAgain"
      @on-amendment-success="filterAgain"
      @status-returned="filterAgain"
      @change-status-to-central-level-process="filterAgain"
    />
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import SearchFilter from './_components/SearchFilter';
import SearchResult from './_components/SearchResult';
import { changeInLot, createCopyToNextYear } from './_api';
import store from '@/store/index';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import moment from 'moment';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'Search',
  mixins: [alert],
  components: {
    PageHeader,
    SearchFilter,
    SearchResult,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title:
          'Manejo de Solicitud de Asistencia Técnica de Ubicación del Estudiante',
        routes: [
          'Inicio',
          'Manejo de Solicitud de Asistencia Técnica de Ubicación del Estudiante',
        ],
      },
      sysParameters: [],
    };
  },
  async created() {
    await this.getSysParam();
  },
  methods: {
    filterAgain() {
      this.$refs.filter.onSearch();
    },
    async closeResultsCallout() {
      this.$refs.results.$refs.resultItems.forEach((item) => {
        item.toggleCallout();
      });
    },
    async changeLot() {
      await changeInLot();
      this.filterAgain();
    },
    async proccessCopyToNextYear() {
      var { data } = await createCopyToNextYear(
        this.$refs.filter.filters.academicYear.id
      );
      if (data) {
        this.ShowToast(
          'Confirmación',
          'La solicitud ha sido enviada para ser procesada.',
          'success'
        );
      } else {
        this.ShowToast(
          'Error',
          'Existe una solicitud en proceso para este año académico.',
          'error'
        );
      }
    },
    goToValidityRequest() {
      this.$router.push({
        path: '/pei/ubication-tech-assistance/validity-request',
      });
    },
    async getSysParam() {
      const { data: sysParameters } = await getSysparameterByNames({
        parameterNames: ['TapRequestCreateCopyToNextYear'],
      });
      this.sysParameters = sysParameters;
    },
  },
  computed: {
    headerActionConfig() {
      return [
        {
          text: 'Procesar Lote - Recomendado al(a la) Secretario(a)',
          icon: 'fas fa-check',
          variant: 'outline-success',
          click: () => this.changeLot(),
          visible: store.getters.HasPermission('taprequest.changestatusinlot'),
        },
        {
          text: 'Procesar Lote - Siguiente Año',
          icon: 'fas fa-check',
          variant: 'outline-success',
          click: () => this.proccessCopyToNextYear(),
          visible: this.canProccessCopyToNextYear,
        },
        {
          text: 'Vigencia de Consultas',
          icon: 'fas fa-file-search',
          variant: 'outline-success',
          visible: store.getters.HasPermission(
            'ubicationtechassistance.validity'
          ),
          click: () => this.goToValidityRequest(),
        },
      ];
    },
    canProccessCopyToNextYear() {
      if (this.sysParameters.length < 1) {
        return false;
      }

      let tapRequestCreateCopyToNextYear =
        this.sysParameters.find(
          (x) => x.name === 'TapRequestCreateCopyToNextYear'
        ) || {};

      return (
        store.getters.HasPermission('taprequest.createcopytonextyear') &&
        moment().isBetween(
          moment(tapRequestCreateCopyToNextYear.effectiveDate),
          moment(tapRequestCreateCopyToNextYear.effectiveEndDate)
        )
      );
    },
  },
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    const persistRoutes = ['ubication-tech-assistance'];

    next(async (vm) => {
      if (persistRoutes.some((x) => x == from.name)) {
        vm.recoveryData();
      } else {
        vm.shouldRecovery = false;
        vm.isAdvanced = false;
      }
    });
  },
};
</script>
